import { render } from "./Main.vue?vue&type=template&id=e9121258&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=e9121258&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e9121258"

export default script